import { API } from "../auth/authApi";

export const createQuestionApi = (data) =>
  API.post("/feedback/question", data);

export const getQuestionsApi = (params) =>
  API.get("/feedback/question", { params });

export const updateQuestionApi = (id, data) =>
  API.put(`/feedback/question/${id}`, data);

export const getSubmissionsApi = (params) =>
  API.get("/feedback/submission", { params });

export const getSubmissionAnswersApi = (submissionId) =>
  API.get(`/feedback/submission/${submissionId}/ans`);

export const downloadSubmissionApi = (locationId) => {
  return API.get("/feedback/download/submission", {
    params: locationId ? { locationId } : {},
    responseType: "blob",
  });
};